import AppError from '@/shared/errors/appError.js'
import setupRequestManager from './setupRequestManager.js'
import { ERROR_CODES } from '@/shared/constants/errors.js'

class NetworkRepo {
  static init() {
    const { sendRequest } = setupRequestManager()
    return new NetworkRepo(sendRequest)
  }

  constructor(sendRequest) {
    this.sendRequest = (method, data) => sendRequest('user', method, data)
  }

  async login(credentials) {
    const data = {
      action: 'login',
      email: credentials.email,
      password: credentials.password,
    }

    const res = await this.sendRequest('post', data)

    // In the new deserializer, the user object is already unpacked into res.user.
    if (res.statusCode === 200) return res.user
    console.log('🚀 ~ NetworkRepo ~ login ~ res:', res)

    const error = new AppError('An unknown error occurred')
    error.setStatusCode(res.statusCode || 500)

    if (res.statusCode === 401) {
      error.message = 'User not authorized'
      error.setCode(ERROR_CODES.INVALID_CREDENTIALS)
    } else if (res.statusCode === 404) {
      error.message = 'User not found'
      error.setCode(ERROR_CODES.NOT_FOUND)
    } else if (res.statusCode === 503) {
      error.message = 'Service unavailable'
      error.setCode(ERROR_CODES.SERVICE_UNAVAILABLE)
    } else {
      error.message = res.message || 'Server error'
      error.setCode(ERROR_CODES.SERVER_ERROR)
    }

    throw error
  }

  async register(registrationData) {
    const data = {
      action: 'register',
      email: registrationData.email,
      password: registrationData.password,
      phoneNumber: '000000000000',
      firstName: registrationData.firstName,
      lastName: registrationData.lastName,
    }

    const res = await this.sendRequest('post', data)

    // With the v3 deserializer, the user is in res.user. 
    if (res.statusCode === 201) return res.user
    console.log('🚀 ~ NetworkRepo ~ register ~ res:', res)

    const error = new AppError('An unknown error occurred')
    error.setStatusCode(res.statusCode || 500)

    if (res.statusCode === 400) {
      error.message = 'Another user already exists'
      error.setCode(ERROR_CODES.INVALID_INPUT)
      error.setMetadata(res)
    } else if (res.statusCode === 409) {
      error.message = 'Another user already exists'
      error.setCode(ERROR_CODES.CONFLICT)
    } else if (res.statusCode === 503) {
      error.message = 'Service unavailable'
      error.setCode(ERROR_CODES.SERVICE_UNAVAILABLE)
    } else {
      error.message = res.message || 'Server error'
      error.setCode(ERROR_CODES.SERVER_ERROR)
    }

    throw error
  }

  async getProfile() {
    const userId = window.localStorage.getItem('user:userId') || ''
    const res = await this.sendRequest('get', { userId })

    if (res.statusCode === 200) return res.user

    const error = new AppError('Failed to fetch profile')
    error.setStatusCode(res.statusCode || 500)
    error.setCode(ERROR_CODES.SERVER_ERROR)
    throw error
  }
}

export default NetworkRepo
